import MissingTeacherReg from './MissingTeacherReg';

export default MissingTeacherReg;
